import type {ComponentProps} from 'react';
import {NumberOfGuestsForm as SharedNumberOfGuestsForm} from '@chekin/shared/guest-form';
import {useReservation} from 'context/reservation';
import {useSummary} from 'context/summary';

type Props = Omit<
  ComponentProps<typeof SharedNumberOfGuestsForm>,
  'allowEditingGuestNumber' | 'defaultNumberOfPets'
>;

function NumberOfGuestsForm(props: Props) {
  const {allowEditingGuestNumber, data: reservation} = useReservation();
  const {data: summary} = useSummary();

  return (
    <SharedNumberOfGuestsForm
      {...props}
      allowEditingGuestNumber={allowEditingGuestNumber}
      defaultNumberOfPets={reservation?.number_of_pets ?? summary?.number_of_pets}
    />
  );
}

export {NumberOfGuestsForm};
